import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
//完整引入element-plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/icon/iconfont.css'
import LCAside from "@/components/LCAside";
import LCHearder from "@/components/LCHearder";
// import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import store from '@/store/index.js'
//iconfont
import '@/assets/fonts/iconfont.css'

// const app = createApp(App);
// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//     app.component(key, component)
// }
//注册element-plus
const app =createApp(App).use(ElementPlus,{
    locale: zhCn,
})
    .use(router).use(Vuex).use(store)
    .component('LCAside', LCAside)
    .component('LCHearder', LCHearder);

// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//     app.component(key, component)
// }
app.mount('#app');

